var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"height":"60px","color":"#1D1C1A","dark":""}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-row',{staticClass:"navRow",attrs:{"align":"center","justify":"center"}},[_c('span',{staticClass:"copyright"},[_vm._v("©Buttery Photography - 2022")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }